import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Home, ArrowLeft, Search } from 'lucide-react'

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found - DevSecRoot</title>
        <meta name="description" content="The page you're looking for doesn't exist." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="min-h-screen flex items-center justify-center pt-16">
        <div className="container-max text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {/* 404 Number */}
            <div className="text-8xl md:text-9xl font-bold text-gradient mb-8">
              404
            </div>

            {/* Error Message */}
            <h1 className="text-3xl md:text-4xl font-bold text-dsr-text mb-6">
              Page Not Found
            </h1>
            
            <p className="text-xl text-dsr-text/70 max-w-2xl mx-auto mb-8">
              The page you're looking for doesn't exist or has been moved. 
              Let's get you back on track to securing your applications.
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <Link to="/" className="btn-primary text-lg px-8 py-4">
                <Home className="w-5 h-5 mr-2" />
                Go Home
              </Link>
              <Link to="/contact" className="btn-secondary text-lg px-8 py-4">
                <Search className="w-5 h-5 mr-2" />
                Get Help
              </Link>
            </div>

            {/* Quick Links */}
            <div className="glass-card p-8 max-w-2xl mx-auto">
              <h2 className="text-xl font-semibold text-dsr-text mb-6">
                Popular Pages
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Link 
                  to="/services" 
                  className="p-4 rounded-lg border border-white/10 hover:border-dsr-accent/30 transition-colors text-dsr-text hover:text-dsr-accent"
                >
                  <div className="font-medium">Our Services</div>
                  <div className="text-sm text-dsr-text/70">Security & Development</div>
                </Link>
                <Link 
                  to="/case-studies" 
                  className="p-4 rounded-lg border border-white/10 hover:border-dsr-accent/30 transition-colors text-dsr-text hover:text-dsr-accent"
                >
                  <div className="font-medium">Case Studies</div>
                  <div className="text-sm text-dsr-text/70">Real-world examples</div>
                </Link>
                <Link 
                  to="/insights" 
                  className="p-4 rounded-lg border border-white/10 hover:border-dsr-accent/30 transition-colors text-dsr-text hover:text-dsr-accent"
                >
                  <div className="font-medium">Insights</div>
                  <div className="text-sm text-dsr-text/70">Latest articles & tips</div>
                </Link>
                <Link 
                  to="/about" 
                  className="p-4 rounded-lg border border-white/10 hover:border-dsr-accent/30 transition-colors text-dsr-text hover:text-dsr-accent"
                >
                  <div className="font-medium">About Us</div>
                  <div className="text-sm text-dsr-text/70">Our team & mission</div>
                </Link>
              </div>
            </div>

            {/* Back Button */}
            <div className="mt-8">
              <button 
                onClick={() => window.history.back()}
                className="inline-flex items-center space-x-2 text-dsr-text/70 hover:text-dsr-accent transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                <span>Go back</span>
              </button>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  )
}

export default NotFoundPage
